<template>
  <Card>
    <View gap="sm" direction="column">
      <View gap="sm" direction="column">
        <Text variant="h4">Held by</Text>
        <Text variant="body-medium" color="secondary">
          {{ firstName }} will be the one conducting the showing. Tallo will use {{ firstName }}'s contact details to
          facilitate the showing
        </Text>
      </View>

      <Card variant="outline-secondary" size="medium">
        <View gap="sm" justify="space-between">
          <View gap="sm">
            <Avatar :user-name="fullName" />
            <View direction="column" justify="center">
              <Text variant="label-small">{{ fullName }}</Text>
              <Text variant="body-small" color="secondary">{{ formatPhoneNumber(showingAgent.phone) }}</Text>
            </View>
          </View>

          <Button variant="outline" size="small" @click="openReassignModal">Edit</Button>
        </View>
      </Card>
    </View>

    <AssignShowingAgentModal ref="reassignModalRef" :showing-id="showingId" :showing-agent-id="showingAgent.id" />
  </Card>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Avatar, Button, Card, Text, View } from '@tallo/design-system';
import { ShowingAgentDto } from '@tallo/investor/showing-agents';
import { formatPhoneNumber } from '@tallo/utility';

import AssignShowingAgentModal from './assign-showing-agent-modal.vue';

const props = defineProps<{ showingId: string; showingAgent: ShowingAgentDto }>();

const reassignModalRef = ref<InstanceType<typeof AssignShowingAgentModal> | null>(null);
const fullName = computed(() => `${props.showingAgent.firstName} ${props.showingAgent.lastName}`);
const firstName = computed(() => props.showingAgent.firstName);

function openReassignModal() {
  reassignModalRef.value?.open();
}
</script>
